export default function Error404 () {
    return (
        <>

        </>
    )
}
